/* Sample Kit PDP — floating add-to-cart bar visibility.

   Rules, from the design:
     * stays hidden until the reader has scrolled past the FIRST add-to-cart
       button — not the whole buy box, which is tall enough that the bar used
       to arrive a full section late
     * hides again whenever ANY add-to-cart button is on screen (including the
       repeat buy box lower down), then returns once that button is behind them
   Tracking the buttons themselves rather than a fixed scroll offset means the
   rule keeps working if the merchant reorders or adds sections. */
(function () {
  'use strict';

  // This file is emitted by every instance of its section, so it can be
  // executed several times on one page. Bind once; later copies bail out.
  if (window.__skpStickyInit) return;
  window.__skpStickyInit = true;

  function setup(bar) {
    // The real add-to-cart buttons are what the bar stands in for, so they are
    // what it tracks. Older markup without them falls back to the whole buy
    // box so the bar still behaves rather than never showing at all.
    var anchors = Array.prototype.slice.call(document.querySelectorAll('[data-skp-atc]'));
    if (!anchors.length) {
      anchors = Array.prototype.slice.call(document.querySelectorAll('[data-skp-buy-box]'));
    }
    if (!anchors.length) return;

    // Anything the bar must not cover. The add-to-cart buttons (so it never
    // competes with the real button) plus the footer (so it stops sitting on
    // top of it at the bottom of the page). Scrolling back up brings it
    // straight back.
    var hideOver = bar.getAttribute('data-hide-over') || '';
    var blockers = anchors.slice();
    hideOver.split(',').forEach(function (sel) {
      sel = sel.trim();
      if (!sel) return;
      try {
        Array.prototype.slice.call(document.querySelectorAll(sel)).forEach(function (el) {
          if (blockers.indexOf(el) === -1) blockers.push(el);
        });
      } catch (e) { /* ignore a malformed selector */ }
    });

    var onScreen = new Set();
    var passedFirst = false;

    function apply() {
      bar.classList.toggle('is-visible', passedFirst && onScreen.size === 0);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) onScreen.add(e.target);
          else onScreen.delete(e.target);
        });
        apply();
      }, { threshold: 0 });
      blockers.forEach(function (b) { io.observe(b); });
    }

    function checkPassed() {
      // "Passed" means the bottom of the first add-to-cart button has left the
      // top of the viewport — the moment the reader loses the real button.
      var rect = anchors[0].getBoundingClientRect();
      var next = rect.bottom < 0;
      if (next !== passedFirst) {
        passedFirst = next;
        apply();
      }
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        checkPassed();
        ticking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', checkPassed, { passive: true });
    checkPassed();
    apply();
  }

  function initAll() {
    document.querySelectorAll('[data-skp-sticky]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-skp-sticky]').forEach(setup);
  });
})();
